// Converts a local calendar date (year/month/day only) to a UTC-midnight
// ISO string for that day — the wire format used for date-only values like
// expiryDate. Shared by DatePickerField (user-picked dates) and anywhere
// else that needs to compute one of these values directly.
export const toUtcIsoDate = (date) => {
  if (!date) return null;
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  ).toISOString();
};

export const formatDateTime = (value, options = {}) => {
  const { fallback = "—", ...formatOptions } = options;
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
    ...formatOptions,
  }).format(date);
};

// Fixed "en" locale + explicit format (distinct from formatDateTime's
// locale-default, dateStyle/timeStyle-based formatting) — shared by
// ManageUserForm and UserViewDialog, which both rendered this exact format.
export const formatDate = (value, fallback = "—") => {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return new Intl.DateTimeFormat("en", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
};
